import React from "react";
import amaxLogo from "../images/amaxLogo.png";
import { Link } from "react-router-dom";
const Step1 = () => {
  return (
    <div className={`p-[20px] bg-custom-image h-dvh`}>
      <div className="flex flex-col items-center justify-end h-full pt-40">
        <div className="size-[166px] mb-[120px]">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </div>
        <Link to="/step2" className="w-full max-w-2xl block mb-[30px]">
          <button className="w-full uppercase bg-transparent rounded-[70px] transition-all duration-300 border border-white hover:bg-white hover:text-black flex justify-center items-center px-2 py-[22px] text-white text-base font-semibold break-words">
            ATHLETE
          </button>
        </Link>

        <Link to="/" className="w-full max-w-2xl block">
          <button className="w-full uppercase bg-transparent rounded-[70px] transition-all duration-300 border border-white hover:bg-white hover:text-black flex justify-center items-center px-2 py-[22px] text-white text-base font-semibold break-words">
            COACH
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Step1;
